import _toUpper from "lodash/toUpper";

class permissionHide {
	constructor($auth, $rootScope) {
		this.$auth = $auth;
		this.$rootScope = $rootScope;
		this.restrict = "A";
	}

	checkGroup(groups) {
		let grps = groups.split(",").map((el) => _toUpper(el));
		return grps.indexOf(_toUpper(this.$auth.getPermissions())) > -1;
	}

	link(scope, element, attributes) {
		let checkPermission = () => {
			element = angular.element(element);
			if (this.checkGroup(attributes["permissionHide"])) {
				element.remove();
			} else {
				element.removeClass("hidden");
			}
		};

		this.$rootScope.$on("$updatePermissions", () => { checkPermission(); });
		checkPermission();
	}

	static create() {
		return new permissionHide(...arguments);
	}

}

class permissionShow {

	constructor($auth, $rootScope) {
		this.$auth = $auth;
		this.$rootScope = $rootScope;
		this.restrict = "A";
	}

	checkGroup(groups) {
		let grps = groups.split(",").map((el) => _toUpper(el));
		return grps.indexOf(_toUpper(this.$auth.getPermissions())) > -1;
	}

	link(scope, element, attributes) {
		let checkPermission = () => {
			element = angular.element(element);
			if (!this.checkGroup(attributes["permissionShow"])) {
				element.remove();
			} else {
				element.removeClass("hidden");
			}
		};

		this.$rootScope.$on("$updatePermissions", () => { checkPermission(); });
		checkPermission();
	}

	static create() {
		return new permissionShow(...arguments);
	}

}

class permissionReadonly {

	constructor($auth, $rootScope) {
		this.$auth = $auth;
		this.$rootScope = $rootScope;
		this.restrict = "A";
	}

	checkGroup(groups) {
		let grps = groups.split(",").map((el) => _toUpper(el));
		return grps.indexOf(_toUpper(this.$auth.getPermissions())) > -1;
	}

	link(scope, element, attributes) {
		let checkPermission = () => {
			element = angular.element(element);
			if (this.checkGroup(attributes["permissionReadonly"])) {
				attributes.$set("disabled", true);
			} else {
				attributes.$set("disabled", false);
			}
		};

		this.$rootScope.$on("$updatePermissions", () => { checkPermission(); });
		checkPermission();
	}

	static create() {
		return new permissionReadonly(...arguments);
	}

}

permissionShow.create.$inject = ["$auth", "$rootScope"];
permissionHide.create.$inject = ["$auth", "$rootScope"];
permissionReadonly.create.$inject = ["$auth", "$rootScope"];

export {permissionShow, permissionHide, permissionReadonly};


// WEBPACK FOOTER //
// ./sources/directives/permissions.directive.js